/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { ObjectDetailAdmin } from './ObjectDetailAdmin'
import {
  ObjectDetailAdminFromJSON,
  ObjectDetailAdminFromJSONTyped,
  ObjectDetailAdminToJSON,
} from './ObjectDetailAdmin'

/**
 *
 * @export
 * @interface EnvelopedObjectObjectDetailAdmin
 */
export interface EnvelopedObjectObjectDetailAdmin {
  /**
   *
   * @type {ObjectDetailAdmin}
   * @memberof EnvelopedObjectObjectDetailAdmin
   */
  body: ObjectDetailAdmin
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedObjectObjectDetailAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedObjectObjectDetailAdmin interface.
 */
export function instanceOfEnvelopedObjectObjectDetailAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedObjectObjectDetailAdminFromJSON(
  json: any,
): EnvelopedObjectObjectDetailAdmin {
  return EnvelopedObjectObjectDetailAdminFromJSONTyped(json, false)
}

export function EnvelopedObjectObjectDetailAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedObjectObjectDetailAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: ObjectDetailAdminFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedObjectObjectDetailAdminToJSON(
  value?: EnvelopedObjectObjectDetailAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: ObjectDetailAdminToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
